import React, { useState } from 'react';
import YouTube from 'react-youtube';

import useAuth from '~/hooks/useAuth';

import dabangBridge from '~/utils/bridge';
import apiCall, { LIVE_URL } from '~/utils/apiCall';

import BG from '~/components/background';

import top from './images/top.png';
import bottom from './images/bottom.png';
import cvs from './images/area-cvs.png';
import forest from './images/area-forest.png';
import station from './images/area-station.png';
import mall from './images/area-mall.png';
import bbq from './images/popup-bbq.png';
import baskin from './images/popup-br.png';
import fail from './images/popup-fail.png';
import ssg from './images/popup-ssg.png';
import starbucks from './images/popup-starbucks.png';

import { Wrap, TopWrap, BottomWrap, AgreeWrap, LabelWrap, Label, Checkbox, Ul, Overlay } from './styled'; 

function Arrow() {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40">
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <path fill="#E6F0FF" d="M0 0H40V40H0z" transform="translate(-391.000000, -2172.000000) translate(0.000000, 2172.000000) translate(391.000000, 0.000000)"/>
              <path stroke="#9FABC4" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4" d="M27 9L27 23 13 23" transform="translate(-391.000000, -2172.000000) translate(0.000000, 2172.000000) translate(391.000000, 0.000000) translate(20.000000, 16.000000) rotate(-315.000000) translate(-20.000000, -16.000000)"/>
          </g>
          </g>
        </g>
      </g>
  </svg>
  );
}

function MainComponent() {
  const [open, setOpen] = useState(false);
  const [imgSrc, setImgSrc] = useState(null);
  const [agree1, setAgree1] = useState(false);
  const [agree2, setAgree2] = useState(false);

  const { authKey } = useAuth();

  const agreeText1 = [
    '1. 개인정보 수집 및 이용 목적 : 당첨자 선정',
    '2. 수집하려는 개인정보의 항목 : 이름, 휴대폰 번호',
    '3. 개인정보의 보유 및 이용 기간 : 당첨자 선정 후 3개월간 보관 후 파기됩니다.',
    '4. 본 개인정보 제공에 동의를 거부할 권리가 있으며 동의 거부 시 이벤트 참여가 제한됩니다.',
    '5. 제공하신 개인정보는 이벤트 경품 발송 용도 외에는 활용하지 않습니다.',
  ];

  const agreeText2 = [
    '1. 개인정보를 제공 받는 자 : 티아이커머스',
    '2. 개인정보를 제공받는자의 개인정보 이용목적 : 경품발송',
    '3. 제공하는 개인정보의 항목 : 휴대폰 번호',
    '4. 개인정보를 제공받는 자의 개인정보 보유 및 이용 기간 : 경품발송 후 3개월간 보관 후 파기',
    '5. 본 개인정보 제공에 동의를 거부할 권리가 있으며 동의 거부 시 이벤트 참여가 제한됩니다.',
    '6. 제공하신 개인정보는 이벤트 경품 발송 용도 외에는 활용하지 않습니다.',
  ];

  const clickImg = async () => {
    if (!agree1) return alert('개인정보 수집/이용 에 대한 동의를 체크 해주세요.');

    try {
      const res = await apiCall.post(`${LIVE_URL}/api/v1/event/20210716`, { authKey });
      const errorCode = [502, 503, 504];

      if (res?.code === 501) {
        alert(res?.msg);

        dabangBridge.ios(call => {
          call.callHandler('ObjC Echo', {
            cmd: 'showLoginAndReload',
          });
        });
    
        dabangBridge.android(call => {
          console.log('android');
          call.showLoginAndReload();
        });

        return;
      }

      if (errorCode.includes(res?.code)) return alert(res?.msg);

      const winning = res?.result === 'fail' ? fail : res?.result === 'ssg' ? ssg : res?.result === 'bbq' ? bbq : res?.result === 'baskin' ? baskin : res?.result === 'starbucks' ? starbucks : null;

      if (winning !== null) {
        setImgSrc(winning);
        setOpen(true);
      }

    } catch(err) {
      console.log(err);
      alert(err?.msg ?? '서버에러가 발생했습니다.');
    }
  }

  const closeModal = () => {
    setOpen(false);

    dabangBridge.ios(call => {
      call.callHandler('ObjC Echo', {
        cmd: 'finishActivity',
      });
    });

    dabangBridge.android(call => {
      console.log('android');
      call.finishActivity();
    });
  }

  return (
    <Wrap>
      <TopWrap>
        <div className="youtube-wrap">
          <YouTube videoId="c6B5ANozUDE" />
        </div>
        <BG width={640} height={2172} imgUrl={top} />
      </TopWrap>

      <AgreeWrap>
        <LabelWrap>
          <Label isCheck={agree1}>
            <Checkbox type="checkbox" checked={agree1} onChange={() => setAgree1(prev => !prev)} />
            <p>개인정보 수집/이용 에 대한 동의</p>
            <Arrow />
          </Label>
  
          {agree1 && (
            <Ul>
              {agreeText1.map((text, key) => (
                <li key={key}>{text}</li>
              ))}
            </Ul>
          )}
        </LabelWrap>
  
        {/* <LabelWrap>
          <Label isCheck={agree2}>
            <Checkbox type="checkbox" checked={agree2} onChange={() => setAgree2(prev => !prev)} />
            <p>개인정보 제공(위탁)에 대한 동의</p>
            <Arrow />
          </Label>
  
          {agree2 && (
            <Ul>
              {agreeText2.map((text, key) => (
                <li key={key}>{text}</li>
              ))}
            </Ul>
          )}
        </LabelWrap> */}
      </AgreeWrap>
  
      <BottomWrap>
        <img className="cvs" src={cvs} alt="" onClick={clickImg} />
        <img className="forest" src={forest} alt="" onClick={clickImg} />
        <img className="station" src={station} alt="" onClick={clickImg} />
        <img className="mall" src={mall} alt="" onClick={clickImg} />
        <BG width={640} height={1630} imgUrl={bottom} />
      </BottomWrap>

      {open && (
        <Overlay>
          <img src={imgSrc} alt="" onClick={closeModal} />
        </Overlay>
      )}
    </Wrap>
  );
}

export default MainComponent;
